// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"23d08b4c","404":"c9d130fd"}[chunkId] + ".chunk.js";
};